<script>
  import { getContext } from "svelte";
  import { countryStore } from "../store/Countries.js";
  import { Tabs, Tab, TabList, TabPanel } from "svelte-tabs";
  import * as util from "../js/util.js";
  import { languageTextsStore } from "../store/languageTexts.js";

  const { close } = getContext("modal");
  const { snackbar } = getContext("app");
  $: currentCountryVersion = $countryStore.currentCountryVersion;
  function stopIfPublished() {
    if (currentCountryVersion.isPublished) {
      snackbar("error", "published versions cannot be editted");
      return true;
    }
  }
  var varLangItems = [];
  async function initConstants() {
    if ($languageTextsStore.langTexts == null) {
      await languageTextsStore.getLanguageTexts();
    }
    varLangItems = await util.fetchJson("api/lang/getvarlangitems");
  }
  initConstants();

  function closeModal() {
    close();
  }
  export let countryVersionVar = {
    varNameKey: "",
    formula: "",
    readonly: false,
    id: 0,
    dataType: "double",
    countryVersionId: 0,
  };

  let itemsToSave = [];
  async function save() {
    if (stopIfPublished()) return;

    if (countryVersionVar.varNameKey == "") {
      snackbar("info", "Fill in a name translation key for the var");
      return;
    }
    var result1 = await countryStore.saveCountryVersionVar(countryVersionVar);
    if (!result1.success) {
      snackbar("error", result.message);
    }

    var hasError = false;
    for (var i = 0; i < itemsToSave.length; i++) {
      var result2 = await languageTextsStore.saveSingle(itemsToSave[i]);
      if (!result2.success) {
        hasError = true;
        snackbar("error", result.message);
      }
    }
    if (result1.success && !hasError) {
      snackbar("info", "Var saved");
      await countryStore.getCountryVersion(countryVersionVar.countryVersionId);
      close();
    }
  }

  function init(element) {
    element.focus();
  }
  function getKey(item) {
    return (
      "variable" + "-" + countryVersionVar.varNameKey + "-" + item.langKeyPart
    );
  }

  function SetText(lang, e) {
    var langKey = e.target.getAttribute("langKey");
    var langItem = itemsToSave.find(
      (lt) => lt.langName == lang && lt.langKey == langKey
    );
    if (!langItem) {
      langItem = { langKey: langKey, langName: lang.langName };
      itemsToSave.push(langItem);
    }
    langItem.langValue = e.srcElement.value;
  }

  function GetText(lang, langItem) {
    var item =
      $languageTextsStore &&
      $languageTextsStore.allKeys &&
      $languageTextsStore.allKeys.find(
        (lt) => lt.langKey == langItem.toLowerCase()
      );
    if (!item) return "";

    var langItemSpecific = item.langTexts.find(
      (lt) => lt.langName == lang.langName.toLowerCase()
    );

    if (!langItemSpecific) return "";

    return langItemSpecific.langValue;
  }
</script>

<div class="modal-header">
  <h5 class="modal-title" id="exampleModalLabel">Variable edit</h5>
</div>
<div class="modal-body">
  <Tabs>
    <TabList>
      <Tab>General</Tab>
      {#each $countryStore.currentCountry.languages as lang}
        <Tab>{lang.langName}</Tab>
      {/each}
    </TabList>
    <TabPanel>
      <label for="naam">var name key</label>
      <input
        readonly={countryVersionVar.id > 0}
        type="text"
        class="form-control"
        placeholder="var name key "
        bind:value={countryVersionVar.varNameKey}
        use:init
        required=""
        id="naam"
        disabled={stopIfPublished()}
      />
      <label for="datatype">data type</label>
      <select
        class="form-control"
        bind:value={countryVersionVar.dataType}
        required=""
        id="datatype"
        disabled={stopIfPublished()}
      >
        <option value="double">double</option>
        <option value="percent">percentage</option>
        <option value="currency">currency</option>
        <option value="text">text</option>
        <option value="date">date</option>
      </select>
      <div class="custom-control custom-checkbox mb-3">
        <input
          type="checkbox"
          id="isReadOnly"
          class="custom-control-input"
          bind:checked={countryVersionVar.readOnly}
          disabled={stopIfPublished()}
        />

        <label for="isReadOnly" class="custom-control-label">
          is readonly for customer
        </label>
      </div>
      <div class="custom-control custom-checkbox mb-3">
        <input
          type="checkbox"
          id="includeInScenarioManager"
          class="custom-control-input"
          bind:checked={countryVersionVar.includeInScenarioManager}
          disabled={stopIfPublished()}
        />

        <label for="includeInScenarioManager" class="custom-control-label">
          include in scenario manager
        </label>
      </div>
      <label for="formula">formula</label>
      <input
        type="text"
        class="form-control"
        placeholder="formula "
        bind:value={countryVersionVar.formula}
        use:init
        required=""
        id="formula"
        disabled={stopIfPublished()}
      />
      <label for="minValue">minValue</label>
      <input
        type="number"
        class="form-control"
        placeholder="minValue"
        bind:value={countryVersionVar.minValue}
        use:init
        required=""
        id="minValue"
        disabled={stopIfPublished()}
      />
      <label for="maxValue">maxValue</label>
      <input
        type="number"
        class="form-control"
        placeholder="maxValue "
        bind:value={countryVersionVar.maxValue}
        use:init
        required=""
        id="maxValue"
        disabled={stopIfPublished()}
      />
    </TabPanel>
    {#each $countryStore.currentCountry.languages as lang}
      <TabPanel>
        Please not that changes apply to all countries and versions using this
        variable
        {#each varLangItems as langItem}
          <label for="{lang}-{getKey(langItem)}">{langItem.label}</label>
          <textarea
            rows="10"
            id="{lang}-{getKey(langItem)}"
            class="form-control"
            placeholder="Text"
            langkey={getKey(langItem)}
            on:change={(e) => SetText(lang, e)}
            value={GetText(lang, getKey(langItem))}
            required=""
            disabled={stopIfPublished()}
          />
        {/each}
      </TabPanel>
    {/each}
  </Tabs>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" on:click={closeModal}>
    Close
  </button>
  <button
    type="button"
    class="btn btn-primary"
    disabled={stopIfPublished()}
    on:click={save}>Save</button
  >
</div>
